import * as React from 'react'
import { HashLink } from 'react-router-hash-link'
import { IdNameProps } from '.'

/**
 * Helper component. The 'to' prop redirects to that menu group's section of the page.
 */
export const OverviewLink = ({ item }: { item: IdNameProps }) => (
  <HashLink
    to={{ hash: `#${item.id}` }}
    className='text-lg tracking-normal text-oo-black-87 block py-3'
  >
    {item.name}
  </HashLink>
)
